import InvestorLiveDealsPage from "./InvestorLiveDealsPage";
export default InvestorLiveDealsPage;
